import { HelloJSServiceDef } from 'hellojs';
import { getOrigin } from 'owa-url/lib/getOrigin';

let MsaConfig: HelloJSServiceDef = {
    name: 'Windows live',

    // REF: http://msdn.microsoft.com/en-us/library/hh243641.aspx
    oauth: {
        version: 2,
        auth: 'https://login.live.com/oauth20_authorize.srf',
        grant: 'https://login.live.com/oauth20_token.srf',
    },

    // Refresh the access_token once expired
    refresh: false,

    login: function (p) {
        if (p.options.force) {
            p.qs.prompt = 'select_account';
        }

        p.qs.redirect_uri = 'https://outlook.office.com/owa/ADPRedirect.aspx';
        p.qs.state.url = getOrigin() + '/mail/oauthRedirect.html';
        p.qs.state.redirect_uri = 'https://outlook.office.com/owa/ADPRedirect.aspx';
        p.qs.aadredir = '1';
    },

    logout: function () {
        return 'https://login.live.com/oauth20_logout.srf?ts=' + new Date().getTime();
    },

    // Authorization scopes
    scope: {},

    // API base URL
    base: 'https://apis.live.net/v5.0/',
};
export default MsaConfig;
